
import React from 'react';
import SVGComponent from '../SVG/SVGComponent';
import { SVG_ICONS } from '../../constants';

/**
 * @module Modals/SavePromptModal
 */

/**
 * @typedef {object} props
 * @property {object} user
 * @property {object} modalData
 * @property {string} modalData.heading
 * @property {string} modalData.modal
 * @property {string} modalData.message
 * @property {string} [modalData.additionalMessage]
 * @property {string} [modalData.email]
 * @property {Function} setOpenModal
 */

/**
 * @param {props} props
 * @returns {view}
 */
export default (props) => (
  <div className="modal modal--open">
    <div className="dialog">
      <div className="dialog__info text-center p-0">
        <SVGComponent
          className="dialog__info-icon"
          src={`${SVG_ICONS.homeIcons}#error-sign`}
        />
        <h3 className="m-t-10">{props.modalData.title}</h3>
        {props.modalData.additionalMessages.length > 0
          && (
            <div className="dialog__info text-center">
              {props.modalData.additionalMessages.map((msg) => (
                <p key={msg}>
                  <strong>
                    {msg}
                  </strong>
                </p>
              ))}
            </div>
          )}
        {props.additionalInfo
          && <p className="text-center m-t-25 m-b-25">{props.additionalInfo}</p>}
      </div>
      <hr className="spacer-line grey m-b-25" />
      <div className="dialog__btn-wrap">
        {' '}
        <div className="btn btn-secondary" onClick={props.cancel}>{props.cancelled}</div>
        {' '}
        <div className="btn btn-primary m-l-10" onClick={props.confirmation}>{props.confirm}</div>
      </div>
    </div>
  </div>
);
